import { render, staticRenderFns } from "./loadingProgram.vue?vue&type=template&id=594d2296&scoped=true&"
import script from "./loadingProgram.vue?vue&type=script&lang=js&"
export * from "./loadingProgram.vue?vue&type=script&lang=js&"
import style0 from "./loadingProgram.vue?vue&type=style&index=0&id=594d2296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d2296",
  null
  
)

export default component.exports